import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import ShowMoreButton from './show-more-button';
import Utils from 'frilans-finans/utils/utils';

class LoyaltyPointsTable extends React.Component {

  static propTypes = {
    rows: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    metaState: PropTypes.object,
    fetching: PropTypes.bool,
    callback: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.renderShowMoreBtn = this.renderShowMoreBtn.bind(this);
    this.callCallback = this.callCallback.bind(this);
  }

  callCallback (e) {
    if (typeof this.props.callback === 'function') {
      this.props.callback(e);
    }
  }

  renderShowMoreBtn () {
    if (!this.props.metaState || this.props.rows.length <= 0) {
      return this.noPointsRow();
    }

    if (this.props.fetching ||
      !this.props.metaState.currentPage ||
      this.props.metaState.currentPage >= this.props.metaState.totalPages) {
      return null;
    }

    return (
      <ShowMoreButton
        text={proxyCounterpart('LOYALTY_POINTS_TABLE_SHOW_MORE_POINTS')}
        graySpinner='true'
        loading={this.props.fetching || false}
        classes=''
        callback={this.callCallback}
      />
    );
  }

  noPointsRow () {
    const transKey = this.props.type === 'pending'
      ? 'LOYALTY_POINTS_TABLE_NO_PENDING_POINTS'
      : 'LOYALTY_POINTS_TABLE_NO_COMPLETE_POINTS';

    return (
      <div className='loyalty-points-no-more-info'>
        {proxyCounterpart(transKey)}
      </div>
    );
  }

  noMoreInfoRow () {
    return (
      <div className='loyalty-points-no-more-info'>
        {proxyCounterpart('LOYALTY_POINTS_TABLE_ALL_POINTS_ARE_LOADED')}
      </div>
    );
  }

  getClickableLoyaltyableIdLink (pointRow) {
    if (pointRow.loyaltyableType === 'App\\Models\\Invoice') {
      return (
        <Link
          to={'/economy/invoices/' + pointRow.loyaltyableId}>{pointRow.loyaltyableId}
        </Link>
      );
    }
    return null;
  }

  getCompanyName (pointRow) {
    if (pointRow.loyaltyableType === 'App\\Models\\Invoice') {
      return pointRow.companyName;
    }
    return proxyCounterpart('LOYALTY_POINTS_TABLE_FRILANS_FINANS');
  }

  render () {
    const pointsRows = [];
    this.props.rows.forEach((pointRow) => pointsRows.push(
      <div
        key={pointRow.id}
        className='loyalty-points-table-row'
      >
        <div className='loyalty-points-table-column'>{moment(pointRow.createdAt).format('YYYY-MM-DD')}</div>
        <div className='loyalty-points-table-column'>{this.getCompanyName(pointRow)}</div>
        <div className='loyalty-points-table-column'>{this.getClickableLoyaltyableIdLink(pointRow)}</div>
        <div className='loyalty-points-table-column'>
          {Utils.numberWithSpaces(Utils.floor(+pointRow.amount * +pointRow.factor))} p
        </div>
      </div>
    ));

    return (
      <div className={'loyalty-points-table' + (this.props.open ? '' : ' hidden')}>
        {pointsRows}
        {this.renderShowMoreBtn()}
      </div>
    );
  }
}

export default LoyaltyPointsTable;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/points-tables/points-table.js
 **/